<template>

    <div class="wrap viewport">
        <div class="container">
            <div class="error_wrap">
                <div class="error">
                    <div class="tit">서비스 이용에<br />불편을 드려 죄송합니다.</div>
                    <p class="txt">서비스 연결이 원활하지 않으니<br />잠시 후 다시 시도해 주세요.</p>
                </div>
            </div><!-- // general_wrap -->
        </div><!-- // container -->

        <at-button :btnName="`이전으로`"
			:btnClass="`f_btn_group`"
			:btnEvent="`prev`"
			v-on:prev="prevAction">
		</at-button>
    </div>
    <!-- // wrap -->

</template>

<script>
export default {
    methods : {
		prevAction () {
			history.back();
		}
	}
}
</script>

<style>

</style>